export interface RequestObject {
  sortExpressions?: any[];
  q?: any;
  pageNumber?: number;
  pageSize?: number;
  filter?: any;
}
